import { IDogClass } from "./dog-class.interface";
import { IDogCoownerInfo } from "../dog";

export class DogRegistrationInfoDto {
  //dog_id: string;
  breed: string;
  variety?: string;
  variation?: string;
  sex: string;
  dob?: Date;
  weight?: number;
  height_at_withers?: number;
  start_minutes?: number;
  time_slot?: string;

  final_response?: string;
  country_of_birth?: string;
  obedience_jump_height?: number;
  akc_obedience_preferred_jump_height?: number;
  rally_jump_height?: number;
  agility_jump_height?: number;
  jump_height_type?: string;

  breeder?: string;
  dam?: string;
  sire?: string;

  registered_name?: string;
  call_name: string;
  prefix_title?: string;
  suffix_title?: string;

  registration_number_type?: string;
  registration_number?: string;

  dog_classes: IDogClass[];
  coowners?: IDogCoownerInfo[];
}
